<template>
  <div>
    <el-select
      :value="providerId"
      :disabled="disabled"
      :clearable="notClearAble ? false : true"
      class="provider-selector"
      filterable
      placeholder="เลือกผู้ให้บริการ"
      style="width: 100%"
      @input="handleChangeProvider"
    >
      <el-option
        v-for="item in providerOptions"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
        <div class="provider-option">
          <img :src="item.logoUrl" class="icon" />
          <div class="name">{{ item.name }}</div>
        </div>
      </el-option>
    </el-select>
    <div class="hide">{{ nameOnSap }}</div>
    <div v-if="isShowProviderVat" class="provider-vat">{{ vatRegisteredText }}</div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { Option, Select } from "element-ui";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    value: {
      type: [Object, String, Number],
      default: null
    },
    initialProviders: {
      type: [Object, Array],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isShowProviderVat: {
      type: Boolean,
      default: false
    },
    notClearAble: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const providers = [];
    return {
      providers
    };
  },
  computed: {
    providerOptions() {
      return this.providers.map((provider) => ({
          ...provider,
          name: provider.nameOnSap
            ? `${provider.name} - ${provider.nameOnSap}`
            : provider.name
        }));
    },
    providerId() {
      if (!this.value) {
        return null;
      }

      return this.value.id || this.value;
    },
    vatRegisteredText() {
      if (!this.value) {
        return "";
      }

      const isVatRegisteredType = typeof this.value.isVatRegistered === "boolean"
      if (isVatRegisteredType) {
        return this.value.isVatRegistered ? "จดVat" : "ไม่จดVat"
      }

      return ""
    },
    nameOnSap() {
      if (!this.value) {
        return "";
      }

      return this.value.nameOnSap
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupProviders();
    },
    async setupProviders() {
      const providers = await this.fetchProviders();

      this.providers = providers.map(provider => {
        const {
          id,
          name,
          icon_url: logoUrl = "https//placehold.it/64",
          is_vat_registered: isVatRegistered,
          name_on_sap: nameOnSap
        } = provider;

        return {
          id: id.toString(),
          name,
          logoUrl,
          isVatRegistered,
          nameOnSap
        };
      });
    },
    async fetchProviders() {
      if (this.initialProviders) {
        return Promise.resolve(this.initialProviders);
      }

      const response = await baanRueJaiClient.admin.subscriptions.providers.list();

      return response.data.result;
    },
    handleChangeProvider(providerId) {
      const provider = this.providers.find(
        p => p.id === providerId
      );

      this.$emit("input", provider);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.provider-selector:hover + .hide {
  width: 100%;
  display: block;
  font-size: 14px;
}

.hide {
  display: none;
}

.provider-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.provider-vat {
  font-size: 14px;
  color: rgb(248, 103, 103);
  text-align: right;
}
</style>
